import config from '@/config/config.js';
import { http } from '@/common/request';
import errorCode from '@/api/error-code.js'
export default {
    createOrder(data){
        let params = { }

        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/order/createOrder",data, method: 'POST', ...options});
    },

    orderPreCreatePriceInfo(data){
        let params = { }

        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/order/orderPreCreatePriceInfo",data, method: 'POST', ...options});
    },
    productPrePriceInfo(data){
        let params = { }

        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/order/productPrePriceInfo",data, method: 'POST', ...options});
    },
    orderPayInfo(orderSn){
        let params = { }
        let data = {}
        data.orderSn = orderSn;

        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/order/orderPayInfo",data, method: 'POST', ...options});
    },

    orderWalletPay(orderSn){
        let params = { }
        let data = {}
        data.orderSn = orderSn;

        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/order/orderWalletPay",data, method: 'POST', ...options});
    },

    batchOrderWalletPay(orderSnList){
        let params = { }
        let data = {}
        data.orderSnList = orderSnList;

        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/order/batchOrderWalletPay",data, method: 'POST', ...options});
    },


    orderDetail(orderSn){
        let params = { }
        let data = {}
        params.orderSn = orderSn;

        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/order/orderDetail",data, method: 'GET', ...options});
    },
    userOrderFilter(filter){
        let params = filter
        let data = {}
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/order/orderList",data, method: 'GET', ...options});
    },


    checkAfterSale(orderSn, orderSkuId){
        let params = {}
        let data = {}
        params.orderSn = orderSn;
        params.orderSkuId = orderSkuId;
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/order/afterSale/checkAfterSale",data, method: 'GET', ...options});
    },

    createAfterSale(data){
        let params = {}
        // let data = {}
        // params.orderSn = orderSn;
        // params.orderSkuId = orderSkuId;
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/order/afterSale/createAfterSale",data, method: 'POST', ...options});
    },

    modifyAfterSale(data){
        let params = {}
        // let data = {}
        // params.orderSn = orderSn;
        // params.orderSkuId = orderSkuId;
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/order/afterSale/modifyAfterSale",data, method: 'POST', ...options});
    },

    closeAfterSale(data){
        let params = {}
        // let data = {}
        // params.orderSn = orderSn;
        // params.orderSkuId = orderSkuId;
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/order/afterSale/closeAfterSale",data, method: 'POST', ...options});
    },




    afterSaleAddDeliveryInfo(data){
        let params = {}
        // let data = {}
        // params.orderSn = orderSn;
        // params.orderSkuId = orderSkuId;
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/order/afterSale/addAfterSaleDeliveryInfo",data, method: 'POST', ...options});
    },


    orderAfterSaleDetail(orderSn){
        let params = {}
        let data = {}
        // params.orderSn = orderSn;
        // params.orderSkuId = orderSkuId;
        const options = {};
        params.orderSn = orderSn;
        options.params = params;
        return  http.request({url:"/api/v3/user/order/afterSale/orderAfterSaleDetail",data, method: 'GET', ...options});
    },



}
